import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { AiOutlineEye, AiOutlineEdit } from "react-icons/ai";
import { Avatar } from "../UI";
import ParentEditModal from "./ParentEditModal/ParentEditModal";
import ParentViewModal from "./ParentViewModal/ParentViewModal";

export default function ParentItem({ data, handleParentUpdate }) {
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const handleCloseView = () => setShowView(!showView);
  const handleCloseEdit = () => setShowEdit(!showEdit);

  return (
    <tr>
      <td>
        <Avatar image={data.profilePhoto} />
      </td>
      <td>{data.firstName + " " + data.lastName}</td>
      <td>{data.email}</td>
      <td>
        <div className="d-flex">
          <Button variant="icon" className="me-2" onClick={handleCloseView}>
            <AiOutlineEye size={18} />
          </Button>
          <Button variant="icon" onClick={handleCloseEdit}>
            <AiOutlineEdit size={18} />
          </Button>
        </div>
        <ParentViewModal
          data={data}
          show={showView}
          handleClose={handleCloseView}
        />
        <ParentEditModal
          data={data}
          show={showEdit}
          handleClose={handleCloseEdit}
          handleParentUpdate={handleParentUpdate}
        />
      </td>
    </tr>
  );
}
